import { Gift, Plus, Percent } from "lucide-react";

const BONUSES = [
  { ad: "Hoş Geldin Bonusu", oran: "%100", tur: "İlk Yatırım", limit: "5.000 ₺", durum: "Aktif" },
  { ad: "Yatırım Bonusu", oran: "%50", tur: "Her Yatırım", limit: "2.500 ₺", durum: "Aktif" },
  { ad: "Kayıp Bonusu", oran: "%25", tur: "Haftalık", limit: "10.000 ₺", durum: "Aktif" },
  { ad: "Arkadaşını Getir", oran: "500 ₺", tur: "Referans", limit: "Sınırsız", durum: "Aktif" },
  { ad: "Doğum Günü Bonusu", oran: "%20", tur: "Yıllık", limit: "1.000 ₺", durum: "Pasif" },
  { ad: "VIP Cashback", oran: "%15", tur: "Aylık", limit: "25.000 ₺", durum: "Aktif" },
];

export default function Bonuslar() {
  return (
    <div className="space-y-5" data-testid="page-bonuslar">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
            <Gift className="text-[#F0651E]" size={22} />
          </div>
          <div>
            <h1 className="text-xl font-extrabold">Bonuslar</h1>
            <p className="text-xs text-slate-500">Kampanya ve bonus tanımları</p>
          </div>
        </div>
        <button className="flex items-center gap-2 rounded-xl bg-[#F0651E] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#d9560f]"><Plus size={16} /> Yeni Bonus</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {BONUSES.map((b) => (
          <div key={b.ad} className="bg-white dark:bg-[#151824] rounded-2xl p-5 shadow-sm border border-slate-100 dark:border-slate-800">
            <div className="flex items-center justify-between">
              <div className="w-9 h-9 rounded-lg bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center text-[#F0651E]"><Percent size={18} /></div>
              <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${b.durum === "Aktif" ? "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300" : "bg-slate-100 text-slate-500 dark:bg-slate-800"}`}>{b.durum}</span>
            </div>
            <h3 className="font-bold mt-3">{b.ad}</h3>
            <div className="text-3xl font-extrabold text-[#F0651E] mt-1">{b.oran}</div>
            <div className="text-xs text-slate-500 mt-2 space-y-0.5">
              <div>Tür: <span className="font-semibold text-slate-700 dark:text-slate-300">{b.tur}</span></div>
              <div>Limit: <span className="font-semibold text-slate-700 dark:text-slate-300">{b.limit}</span></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
